// BrowseTab.jsx
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import Tabs from '../component/Tabs.jsx';
import Tab from '../component/Tab.jsx';

import trackMixpanel, {
  EventTypes,
  getViewId,
  ButtonId,
} from '../resource/mixpanel.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';

import { color, headerHeight } from '../style/variables.js';
import media from '../style/media.js';

const tabObject = {
  explore: {
    titleI18nKey: 'explore_title',
    mixpanelButtonId: ButtonId.Tab.TabExplore,
  },
  following: {
    titleI18nKey: 'title_following_list',
    mixpanelButtonId: ButtonId.Tab.TabFollowing,
  },
};
const tabStyle = {
  opacity: 1,
};

export const BrowseTab = ({ activeTab, tabs, replace }) => {
  const { t } = useTranslation();
  const handleTabChange = useCallback(
    (event, value) => {
      trackMixpanel({
        type: EventTypes.USER_CLICKED,
        payload: {
          viewId: getViewId({
            pathname: window.location.pathname,
          }),
          buttonId: tabObject[value]?.mixpanelButtonId,
        },
      });
      return replace({
        pathname: `/${value}${location.search}`,
      });
    },
    [replace]
  );
  if (!tabs.length) {
    return null;
  }
  return (
    <StyledBrowseTab>
      <Tabs value={activeTab} onChange={handleTabChange}>
        {tabs.map(tabId => {
          const isActive = tabId === activeTab;
          const i18nKey = tabObject[tabId]?.titleI18nKey;
          const title =
            t(i18nKey, {
              ns: TranslationNamespace.GENERAL,
            }) || i18nKey;
          return (
            <Tab
              key={tabId}
              value={tabId}
              labelStyle={tabStyle}
              label={<TabText isActive={isActive}>{title}</TabText>}
            />
          );
        })}
      </Tabs>
    </StyledBrowseTab>
  );
};

BrowseTab.propTypes = {
  activeTab: PropTypes.string,
  tabs: PropTypes.array,
  replace: PropTypes.func,
};

BrowseTab.defaultProps = {
  activeTab: '',
  tabs: [],
  replace: () => null,
};

const StyledBrowseTab = styled.div`
  position: sticky;
  top: ${headerHeight}px;
  left: 0px;
  z-index: 8; // Should higher than HomeSearchBar
  width: 100%;
  display: none;
  border-bottom: 1px solid rgba(100, 100, 100, 0.15);
  background-color: ${color.black};
  ${media.mobile`
    display: block;
  `};
`;

const TabText = styled.h2`
  font-size: 16px;
  margin: 0;
  font-weight: normal;
  ${media.mobile`
    font-size: 14px;
  `};
`;

export default BrowseTab;
